import { RequestModelInterface } from "@/service/models/request-model-interface";
import { XmlDocumentWrapper } from "@/utilities/xml-helpers/xml-document-wrapper";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";

export class DrugSampleConcentration implements RequestModelInterface
{
    public constructor(
        public analyteId: string,
        public value: number,
        public unit: string,
    )
    {
    }

    public getXml(doc: XmlDocumentWrapper): XmlElementWrapper
    {
        const element = doc.createElement("concentration");

        element.appendNewElement("analyteId", this.analyteId);
        element.appendNewElement("value", this.value.toString());
        element.appendNewElement("unit", this.unit);

        return element;
    }
}
